import { Component } from '@angular/core';

@Component({
  selector: 'app-relogio',
  templateUrl: './relogio.component.html',
  styleUrls: ['./relogio.component.scss']
})
export class RelogioComponent {

  date:Date =new Date();
  hours:any;
  minutes:any;
  seconds:any;
  currentLocale: any;

  isTwelveHrFormat:false | undefined;
  test:any;
  constructor(){

    setInterval(() =>{
   const currentDate = new Date();
   this.date = currentDate;
    }, 1000);
    this.date.toDateString()
  }

}
